import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import './radio-button.scss';
import { Tooltip } from '../../Tooltip';
import { InfoIcon } from '../../SvgIcons';

export class RadioButtonSimpleField extends React.PureComponent {
  static propTypes = {
    data: PropTypes.arrayOf(
      PropTypes.shape({
        title: PropTypes.string.isRequired,
        value: PropTypes.any.isRequired,
      }),
    ).isRequired,
    columnsCount: PropTypes.number,
    onChange: PropTypes.func,
    value: PropTypes.any,
    dataTestId: PropTypes.string,
  };

  static defaultProps = {
    columnsCount: 1,
    onChange: () => {},
  };

  state = {
    value: null,
  };

  getRadioItemStyle = () => {
    const { columnsCount, disabled } = this.props;
    const disabledStyle = disabled
      ? {
          pointerEvents: 'none',
          color: '#A6AEB6',
        }
      : {};

    return {
      width: `calc((100% - ${columnsCount - 1} * 16px) / ${columnsCount})`,
      ...disabledStyle,
    };
  };

  handleChange = (newValue) => {
    const { onChange } = this.props;
    this.setState({
      value: newValue,
    });
    onChange(newValue);
  };

  renderValue = (dataItem, index) => {
    const { data = [], columnsCount, name, disabled, dataTestId } = this.props;
    const { value } = this.state;

    let valueForCompare =
      this.props.value === false ? this.props.value : this.props.value || value;
    let itemValueForCompare = dataItem.value;

    if (typeof valueForCompare === 'number') {
      valueForCompare = valueForCompare.toString();
    }
    if (typeof itemValueForCompare === 'number') {
      itemValueForCompare = itemValueForCompare.toString();
    }

    return (
      <label
        key={index}
        className="radio-button"
        style={{
          ...this.getRadioItemStyle(),
          paddingBottom: index < data.length - columnsCount ? '12px' : '0',
        }}
        data-testid={`radio-button-${name}-${dataItem.value}`}
        data-testid={
          dataTestId
            ? `${dataTestId}-item-${dataItem.value}`
            : `radio-button-${name}-${dataItem.value}`
        }
        onClick={(event) => {
          event.currentTarget.blur();
          this.handleChange(dataItem.value);
        }}
        onKeyDown={(event) => {
          if (event.key !== 'Enter') return;
          this.handleChange(dataItem.value);
        }}
        tabIndex={1}
      >
        <div
          className={classNames(
            'radio-button__checkmark',
            itemValueForCompare === valueForCompare
              ? disabled
                ? '_checked-disabled'
                : '_checked'
              : '',
            disabled ? 'radio-button__checkmark-disabled' : '',
          )}
        />
        <div>
          {dataItem.title}
          {dataItem.tooltipInfo && (
            <Tooltip
              style={{ top: '2px', left: '8px' }}
              width={dataItem.tooltipWidth}
              type={dataItem.tooltipType}
              info={dataItem.tooltipInfo}
            >
              <InfoIcon width="17px" height="17px" />
            </Tooltip>
          )}
        </div>
      </label>
    );
  };

  renderMissingButtons = () => {
    let missingArray = [];
    const { data = [], columnsCount } = this.props;
    const missingLength =
      columnsCount - (data.length % columnsCount || columnsCount);
    for (let i = 0; i < missingLength; i++) {
      missingArray.push(<label style={this.getRadioItemStyle()} key={i} />);
    }
    return missingArray;
  };

  render() {
    const { data, name, label, labelClassName = '', dataTestId } = this.props;

    return (
      <>
        {label && (
          <span className={`radio-left-label ${labelClassName}`}>{label}</span>
        )}
        <div
          data-testid={`radio-container-${name}`}
          data-testid={
            dataTestId ? `${dataTestId}-container` : `radio-container-${name}`
          }
          className="radio-button-container"
        >
          {data.map(this.renderValue)}
          {this.renderMissingButtons()}
        </div>
      </>
    );
  }
}
